<script setup>
import { ToastProvider, Toaster } from '@/components/ui/toast'
import ChatBot from '@/components/custom/ChatBot';

const config = useRuntimeConfig();

const favicon = computed(() => {
  return config.public.isMain
    ? '/images/spotsurferLogo.png'
    : globalConfig()?.config?.site?.assets.find((a) => a.type === 'FAVICON')?.url;
});

useHead({
  htmlAttrs: {
    lang: 'en'
  },
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: favicon
    },
    {
      rel: 'canonical',
      href: window.location
    }
  ]
});
</script>

<template>
  <NuxtLoadingIndicator />
  <!-- <ChatBot v-if="config.public.isMain && useUser().hasFeature('CHATBOT')"/> -->
  <div
    class="transition-all duration-300 ease-in-out"
    :style="{
      width: useCosmo().isOpen ? 'calc(100vw - 400px)' : '100vw'
    }"
  >
  <NuxtLayout>
    <NuxtPage />
    <ToastProvider>
      <div class="z-[999999]" :class="[useCosmo().isOpen ? 'chat-open' : '']">
        <Toaster />
      </div>
    </ToastProvider>
  </NuxtLayout>
  </div>
</template>

<style>
.chat-open ol {
  left: 0 !important;
}

@media (max-width: 767px) {
  input, select, textarea {
    font-size: 16px !important;
  }
  .text-sm {
    font-size: 16px !important;
  }
}
</style>
